import ClientService from '../../services/client-service';
import getActivityListDataQuery from '../../graphql/query/get-activity-list-data.graphql';
import deleteActivityListMutation from '../../graphql/mutation/delete-activity-list.graphql';
import saveActivityListDataMutation from '../../graphql/mutation/save-activity-list-data.graphql';
import saveActivityStatusListMutation from '../../graphql/mutation/save-activity-status-list.graphql';
import saveActivityListMutation from '../../graphql/mutation/save-activity-list.graphql';

export default class ActivityListApi {
  public static getActivityListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlQueryRequest(getActivityListDataQuery, payload);
  }

  public static deleteActivityList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(deleteActivityListMutation, payload);
  }

  public static saveActivityListData(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveActivityListDataMutation, payload);
  }

  public static saveActivityStatusList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveActivityStatusListMutation, payload);
  }

  public static saveActivityList(payload: ActionPayload): Promise<ActionResponse | null> {
    return ClientService.sendGraphqlMutationRequest(saveActivityListMutation, payload);
  }
}
